// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__cgtGr","content__image":"styles_content__image__D6mP3","pulse":"styles_pulse___RVXy","jump":"styles_jump__RjPwJ"};